<template>
 <svg
  xmlns="http://www.w3.org/2000/svg"
  width="11"
  height="11"
  viewBox="0 0 11 11"
  fill="none"
  aria-hidden="true"
 >
  <!-- The exported glyph is not centred in its own 11x11 frame: it spans
       x 0.7285-9.8154 and y 1.4001-10.4869, so its centre is (5.272, 5.943)
       against a box centre of (5.5, 5.5) — 0.23 left and 0.44 low. At 11px that
       is sub-pixel, but the plus sits inside a 24px circle on the calendar cards
       where the eye reads it against the ring, and it showed as hanging low and
       left (Nick, UNB-700 follow-up).
       The glyph is square (9.0869 both ways), so a pure translate centres it —
       no rescaling, and the path stays exactly as Figma exported it. -->
  <g transform="translate(0.228057 -0.443475)">
   <path
    d="M5.27194 10.4869L5.27194 5.94348L9.81537 5.94348M5.27194 1.40005L5.27151 5.94391L0.728516 5.94348"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
   />
  </g>
 </svg>
</template>
